import Form, { FormProps } from "../../../ui-components/forms/form/Form";
import { TextProps } from "./TextField";

export type SendLinkFormProps = TextProps;
export const TypedForm: (props: FormProps<SendLinkFormProps>) => JSX.Element =
  props => Form<SendLinkFormProps>(props);
